import { ReactSession } from '../utils/ReactSession.jsx';
import {Navigate} from "react-router-dom";
import {AES, enc} from "crypto-js";
import LegacyDemoPanel from "./LegacyDemoPanel.jsx";
import DemoPanel from "./DemoPanel.jsx";
import {compareRole, iAmHigherAuthority} from "../libs.jsx";
import SessionReload from "./component-assets/SessionReload.jsx";
import DemoPanelCloud from "./DemoPanelCloud.jsx";

function Demo(props) {
    let dData, bData, pageContent;

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), import.meta.env.VITE_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    if (dData.migrated){
        if (dData?.campusData[dData.acnt.toString()]?.is_cloud){
            pageContent = <DemoPanelCloud />;
        }else{
            pageContent = <DemoPanel />;
        }
    }
    else{
        pageContent = <LegacyDemoPanel />;
    }

    return (dData?.slauth === true && dData?.tKey != null && dData?.tKey !== "" && dData?.acnt != null && (!compareRole("corporate-admin", dData) || iAmHigherAuthority(99, dData?.role_weight))) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {pageContent}
        </>
    ) : <Navigate to={"/"}/>;
}

export default Demo;